import "@babel/polyfill";
import Vue from 'vue'




// set vue-session
import VueSession from 'vue-session'
Vue.use(VueSession, {
  persist: true
})



// eventBus definitions
Vue.prototype.$eventBus = new Vue();






// add library
import $ from 'jquery'
// import jQuery from 'jquery'
window.$ = $


// add publishing bootstrap
import('../public/ssflex/assets/js/bootstrap.bundle.min')




// add mixins
import CommonsMixin from '@/commons/mixins/commons.mixin'   // 공통
import SessionMixin from '@/commons/mixins/sessions.mixin'  // 세션
import HWAPP from '@/commons/mixins/hwapp.mixin'  // 앱 브릿지

import BoardVOs from '@/commons/vo/boards'  // 게시판
import CompanyVOs from '@/commons/vo/company' // 회사, 계정
import EducationVOs from '@/commons/vo/educations'  // 교육
import CartVOs from '@/commons/vo/cart' //장바구니
import OrderInfoVOs from '@/commons/vo/order' //주문
import DisplayVOs from '@/commons/vo/displays' //주문


Vue.mixin(CommonsMixin)
Vue.mixin(SessionMixin)
Vue.mixin(HWAPP)
Vue.mixin(BoardVOs)
Vue.mixin(CompanyVOs)
Vue.mixin(EducationVOs)
Vue.mixin(CartVOs)
Vue.mixin(OrderInfoVOs)
Vue.mixin(DisplayVOs)




// add utils
import APIs from '@/commons/APIs'
import axiosCaller from '@/commons/utils/axios.caller'
import webUtils from '@/commons/utils/web.utils'
import pageUtils from '@/commons/utils/page.utils'
import stringUtils from '@/commons/utils/string.utils'
import arrayUtils from '@/commons/utils/array.utils'
import numberUtils from '@/commons/utils/number.utils'
import swalUtils from '@/commons/utils/swal.utils'
import codeUtils from '@/commons/utils/code.utils'
import mediaUtils from '@/commons/utils/media.utils'

Vue.prototype.$ = $;
Vue.prototype.APIs = APIs;
Vue.prototype.axiosCaller = axiosCaller;
Vue.prototype.webUtils = webUtils;
Vue.prototype.pageUtils = pageUtils;
Vue.prototype.stringUtils = stringUtils;
Vue.prototype.arrayUtils = arrayUtils;
Vue.prototype.numberUtils = numberUtils;
Vue.prototype.swalUtils = swalUtils;
Vue.prototype.codeUtils = codeUtils;
Vue.prototype.mediaUtils = mediaUtils;

window.$ = $
window.jQuery = $
window.APIs = APIs
window.webUtils = webUtils
window.pageUtils = pageUtils
window.stringUtils = stringUtils
window.arrayUtils = arrayUtils
window.numberUtils = numberUtils
window.swalUtils = swalUtils
window.codeUtils = codeUtils
window.mediaUtils = mediaUtils

// css
const subDomain = webUtils.getSubdomain()
/*const cssWWW = "../public/ssflex/assets/css/style.css";
const cssCS1 = "../public/ssflex_cs1/assets/css/style.css";
if ( subDomain === 'www' ) {
	import(cssWWW);
} else {
	import(cssCS1);
}*/



// add filters
import "@/commons/filters/array.filter"
import "@/commons/filters/date.filter"
import "@/commons/filters/number.filter"
import "@/commons/filters/string.filter"




// External JS LOAD Library
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);



// add vue-sweetalert2
import vueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '../public/ssflex/assets/css/sweetalert2.css';
Vue.use(vueSweetalert2)





// Font Awesome
import '@fortawesome/fontawesome-free/js/all'
// import '@fortawesome/fontawesome-free/js/fontawesome'
// import '@fortawesome/fontawesome-free/js/brands'



// add Message Kor
/*import message_kor from '@/commons/mixins/messages_kor.mixin'
window.$messages = message_kor
Vue.prototype.$messages = message_kor*/



Vue.config.productionTip = false


import App from '@/App'
import routes from './vue.routes'


import App_cs1 from '@/cs1/cs1App'
import routes_cs1 from './cs1/cs1.routes'

/**
 * 솔루션 메인 페이지 or 고객사 분기
 */
if ( subDomain === 'www' ) {

	//import("@/../public/ssflex/assets/css/style.css")

	new Vue({
		// render: h => h(App),
		render: h => h(App),
		router: routes,
	}).$mount('#app')
	import('@/../public/ssflex/assets/js/common-ui')

} else {

	//import("@/../public/ssflex_cs1/assets/css/style.css")

	new Vue({
		// render: h => h(App),
		render: h => h( App_cs1 ),
		router: routes_cs1,
	}).$mount('#app')
	import('@/../public/ssflex_cs1/assets/js/common')
}


//document.title = "HWSolutions";

// add publishing common-ui
//import('../public/assets/js/common-ui')
/*setTimeout( () => {
  import('../public/assets/js/common-ui')
}, 500)*/
/*
this.$nextTick(() => {
  import('../public/assets/js/common-ui')
})*/
